import React, { useContext } from 'react';

import { type IAccessibility } from './AccessibilityProvider';

const accessibilityDefault: IAccessibility = {
  storytellerEnabled: false,
  setStorytellerEnabled: undefined,
  isCursorBig: false,
  setIsCursorBig: undefined,
  isHightlightLink: false,
  setIsHightlightLink: undefined,
  isDislexic: false,
  setIsDislexic: undefined,
  fontSize: 0,
  setFontSize: undefined,
  languaje: 'es',
  setLanguaje: undefined,
  langTeller: 'es/MX',
  setLangTeller: undefined,
  isReadingGuideEnabled: false,
  setIsReadingGuideEnabled: undefined,
};

const AccessibilityContext = React.createContext<IAccessibility>(accessibilityDefault);

const useAccessibilityContext = () => useContext(AccessibilityContext);

export { useAccessibilityContext };

export default AccessibilityContext;
